// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ThemeToggle_toggle__hx0tR","disc":"ThemeToggle_disc__63tpY"};